(() => {
  const existingLoader = window.__productVideoStoriesLazyLoader;

  if (existingLoader?.init) {
    existingLoader.init();
    return;
  }

  const selector = '[data-pvs-lazy-video]';
  const observedVideos = new WeakSet();
  let observer = null;

  const loadVideo = (video) => {
    if (!video || video.dataset.pvsLoaded === 'true') return;

    for (const source of video.querySelectorAll('source[data-src]')) {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
    }

    video.dataset.pvsLoaded = 'true';
    video.load();

    if (video.dataset.pvsAutoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      video.play().catch(() => {});
    }
  };

  const getObserver = () => {
    if (observer || !('IntersectionObserver' in window)) return observer;

    observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          loadVideo(entry.target);
          observer.unobserve(entry.target);
        }
      },
      { rootMargin: '900px 0px' }
    );

    return observer;
  };

  const init = (root = document) => {
    const videos = root.querySelectorAll(selector);
    const lazyObserver = getObserver();

    for (const video of videos) {
      if (observedVideos.has(video) || video.dataset.pvsLoaded === 'true') continue;
      observedVideos.add(video);

      if (lazyObserver) {
        lazyObserver.observe(video);
      } else {
        window.setTimeout(() => loadVideo(video), 1200);
      }
    }
  };

  window.__productVideoStoriesLazyLoader = { init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
